import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../store/store';
import { initializeAuth, logout } from '../store/slices/authSlice';
import {
  mirrorPlatformAuthCookiesFromStorage,
  isTokenExpired,
  shouldLogoutFromPlatformSso,
} from '../utils/platformAuthCookie';

interface AuthProviderProps {
  children: React.ReactNode;
}

const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    const token = localStorage.getItem('token');
    const refreshToken = localStorage.getItem('refreshToken');
    if (shouldLogoutFromPlatformSso(!!token)) {
      dispatch(logout());
      return;
    }
    if (token && !isTokenExpired(token)) {
      mirrorPlatformAuthCookiesFromStorage({
        accessToken: token,
        refreshToken: refreshToken && !isTokenExpired(refreshToken) ? refreshToken : token,
      });
    }
    dispatch(initializeAuth());

    const syncLogoutFromSisterApp = () => {
      if (shouldLogoutFromPlatformSso(!!localStorage.getItem('token'))) {
        dispatch(logout());
      }
    };
    window.addEventListener('focus', syncLogoutFromSisterApp);
    const onVisibility = () => {
      if (document.visibilityState === 'visible') syncLogoutFromSisterApp();
    };
    document.addEventListener('visibilitychange', onVisibility);
    return () => {
      window.removeEventListener('focus', syncLogoutFromSisterApp);
      document.removeEventListener('visibilitychange', onVisibility);
    };
  }, [dispatch]);

  return <>{children}</>;
};

export default AuthProvider;
